module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAADIAQMAAACXljzdAAAABlBMVEUAAADKyspz+74zAAAAAXRSTlMAQObYZgAAAGRJREFUWMPt1rENwDAIBdEvMYDb7D8JI3kDovTQJKQxh+iufRIotvJVXVz52Iui5jJlrLn4kII3vOENbzO8XZ+LhhRrLn5qWfHMTuzUBW94ayrcU+4p/xve8IY3vP3sbYXSrcsNNdGPuYO9ORsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/add_image@2x.png
// module id = 835
// module chunks = 0 1 2 3 4 5